import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import FeeForm from '../../components/Fees/FeeForm';
import UserRole from '../../../shared/AuthRoles';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AddFeePage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const loggedInUser = UserRole();
    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        if (loggedInUser.role !== 'owner_admin') {
            navigate(`/permissionDenied`, {
                state: {
                    name: 'feesPage',
                },
            });
        }
    }, [loggedInUser.role]);

    const handleBackButton = () => {
        navigate(`/fees`);
    };

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile ? '80vh' : '95%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <FeeForm />
            <CustomButton
                onClick={handleBackButton}
                color='primary'
                sx={{
                    display: isMobile || isIpad ? 'none' : 'flex', // Hide on mobile
                    marginLeft: '-8px',
                    '&:hover': {
                        cursor: 'pointer',
                        color: theme.palette.textAccent.main,
                        backgroundColor: 'transparent',
                        background: 'none',
                    },
                }}
            >
                <ArrowBackIcon />{' '}
                <Typography
                    sx={{
                        fontSize: '12px',
                        paddingLeft: '5px',
                    }}
                >
                    Back to list
                </Typography>
            </CustomButton>
        </Grid>
    );
};

export default AddFeePage;
